import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AccountLogoReplacementFailedAction = {
	type: 'ACCOUNT_LOGO_REPLACEMENT_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AccountLogoReplacementFailedAction => ({
	type: 'ACCOUNT_LOGO_REPLACEMENT_FAILED',
	payload,
});
